import { useState } from 'react';
import { NudosSelectButton } from '../../../../../../../components/NudosComponents';
import { createNewOrganizationCommercialPreference } from '../../../../../../../services/bussines';
import { IorganizationCommercialPreference } from '../../../../../../../types/bussines';
import { displayErrorNotification } from '../../../../../../../utils/displayNudosStandardNotifications';
import NudosConfirmActionModal from '../../../../../../../components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';
import './PurchaseOrderSelection.scss';

const PurchaseOrderSelection = ({
  organizationId,
  organizationCommercialPreferencesMap,
  updateData,
  typeOfPurchaseOrder = '',
  uuid = ''
}: {
  organizationId?: string;
  organizationCommercialPreferencesMap?: Map<string, IorganizationCommercialPreference>;
  updateData?: () => void;
  typeOfPurchaseOrder?: string;
  uuid?: string;
}) => {
  const [purchaseModalType, setPurchaseModalType] = useState<'required' | 'notRequired'>();
  const [modalButtonIsLoading, setModalButtonIsLoading] = useState(false);

  const previouslyDefinedPreference = organizationCommercialPreferencesMap
    ? organizationCommercialPreferencesMap.get(uuid)
    : undefined;

  const parsedValue =
    typeof previouslyDefinedPreference?.commercialPreferenceValue === 'string'
      ? JSON.parse(previouslyDefinedPreference.commercialPreferenceValue)
      : previouslyDefinedPreference?.commercialPreferenceValue;

  const isPurchaseOrderRequiredCurrently = previouslyDefinedPreference ? parsedValue : false;

  const ModalConfirmationText = ({ isActivating }: { isActivating: boolean }) => (
    <div className="modalConfirmationText">
      <p>
        {isActivating ? 'Al activar esta selección' : 'Con esta selección'}{' '}
        <strong>
          {isActivating ? 'se generarán facturas automáticamente (sin PO)' : 'no se generarán facturas automáticamente'}
        </strong>{' '}
        para esta empresa. <br />
        ¿Seguro que deseas continuar?
      </p>
    </div>
  );

  const shouldRequirePO = purchaseModalType === 'required';
  const modalText = <ModalConfirmationText isActivating={shouldRequirePO} />;

  const modalContinueButtonText = shouldRequirePO
    ? 'Sí, activar facturación automática'
    : 'Sí, desactivar facturación automática ';

  const closeModal = () => setPurchaseModalType(undefined);

  const updatePurchaseOrderPreference = async ({ requirePO = false, uuid }: { requirePO: boolean; uuid?: string }) => {
    if (!organizationId) return;
    try {
      setModalButtonIsLoading(true);
      if (uuid) {
        const body = {
          organizationId: +organizationId,
          commercialPreferenceTypeUuid: uuid,
          commercialPreferenceValue: JSON.stringify(requirePO)
        };
        await createNewOrganizationCommercialPreference(body);
      }
    } catch (error) {
      displayErrorNotification();
    } finally {
      updateData && updateData();
      setModalButtonIsLoading(false);
      closeModal();
    }
  };

  const requirePurchaseOrder = async () => {
    await updatePurchaseOrderPreference({
      requirePO: true,
      uuid
    });
  };

  const dontRequirePurchaseOrder = async () => {
    await updatePurchaseOrderPreference({
      requirePO: false,
      uuid
    });
  };

  const handleModalAction = async () => {
    if (!shouldRequirePO) {
      await requirePurchaseOrder();
    } else {
      await dontRequirePurchaseOrder();
    }
  };

  return (
    <div className="purchaseOrderSelection">
      {!!purchaseModalType && (
        <NudosConfirmActionModal
          firstButtonAction={closeModal}
          secondButtonAction={handleModalAction}
          firstButtonText="No, cancelar"
          secondButtonText={modalContinueButtonText}
          modalText={modalText}
          isLoading={modalButtonIsLoading}
          customMarginTopContainerButtons="12px"
        />
      )}
      <div className="purchaseOrderTitle">{`Facturación automática en ${typeOfPurchaseOrder}`}</div>
      <div className="purchaseOrderOptions">
        <div className="optionPO">
          <NudosSelectButton
            colorPalette="black"
            handleClickButton={() => setPurchaseModalType('required')}
            isButtonActive={!isPurchaseOrderRequiredCurrently}
          />
          <div className="optionText">Sí aplica</div>
        </div>
        <div className="optionPO">
          <NudosSelectButton
            colorPalette="black"
            handleClickButton={() => setPurchaseModalType('notRequired')}
            isButtonActive={isPurchaseOrderRequiredCurrently}
          />
          <div className="optionText">No aplica</div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderSelection;
